import { render, staticRenderFns } from "./StocksTicker.vue?vue&type=template&id=c217ac98&scoped=true&"
import script from "./StocksTicker.vue?vue&type=script&lang=js&"
export * from "./StocksTicker.vue?vue&type=script&lang=js&"
import style0 from "./StocksTicker.vue?vue&type=style&index=0&id=c217ac98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c217ac98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
